import { BreadcrumbItem } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { GetCollectionQuery } from '../../../common/generated-types';

@Component({
    selector: 'vsf-collection-breadcrumbs',
    templateUrl: './collection-breadcrumbs.component.html',
    styleUrls: ['./collection-breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CollectionBreadcrumbsComponent {

    @Input() breadcrumbs?: NonNullable<GetCollectionQuery['collection']>['breadcrumbs'] = [];
    @Input() linkLast = false;

    get items(): BreadcrumbItem[] {
        const categories = (this.breadcrumbs ?? []).filter(crumb => crumb.name !== '__root_collection__' && crumb.slug !== '__root_collection__');
        return [{ label: 'Home', link: '/' }, ...categories.map((crumb, index) => ({
            label: crumb.name,
            link: index < categories.length - 1 || this.linkLast
                ? (crumb.slug === 'consolidated-feed' ? '/consolidated-feed' : ['/category', crumb.slug]) : undefined,
        }))];
    }
}
